#import "../fragments/domain-fragment.graphql"

query GetDomains {
    domains {
        ...DomainFragment
    }
}
